import { render, staticRenderFns } from "./AzTextViewEditFileInputNovo.vue?vue&type=template&id=c8530070&"
import script from "./AzTextViewEditFileInputNovo.vue?vue&type=script&lang=js&"
export * from "./AzTextViewEditFileInputNovo.vue?vue&type=script&lang=js&"
import style0 from "./AzTextViewEditFileInputNovo.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VFileInput,VTextField})
